import type { settings as en } from '@/i18n/locales/en/settings';
import type { Translation } from '@/i18n/types';

export const settings: Translation<typeof en> = {
  title: 'Configuración',
  lead: 'El perfil de tu empresa, la identidad visual y la configuración de privacidad.',
  noCompany: 'No hay ninguna empresa activa seleccionada.',
  adminOnly:
    'Solo un administrador de la plataforma puede cambiar esto — puedes ver los valores actuales.',
  save: 'Guardar',
  nav: {
    label: 'Menú de configuración',
    profile: 'Perfil',
    branding: 'Identidad visual',
    privacy: 'Privacidad',
    modules: 'Módulos',
  },
  profile: {
    title: 'Perfil',
    name: 'Nombre de la organización',
    industry: 'Sector',
    industryHint: 'Texto libre, p. ej. "Logística" o "Sanidad".',
    employeeCount: 'Número de empleados',
    plan: 'Plan',
    planPlaceholder: 'Ver Suscripción',
  },
  branding: {
    title: 'Identidad visual',
    lead: 'Tu logotipo y color de acento, con una vista previa en vivo.',
    logo: 'Subir logotipo',
    logoHint: 'Se sube de inmediato; o introduce una URL existente debajo.',
    logoUrl: 'URL del logotipo',
    upload: {
      uploading: 'Subiendo…',
      tooLarge: 'El archivo es demasiado grande (máx. 10MB).',
      invalidType: 'Tipo de archivo no permitido.',
    },
    accentColor: 'Color de acento',
    preview: 'Vista previa en vivo',
    colors: {
      mint: 'Menta',
      pine: 'Pino',
      ink: 'Tinta',
      amber: 'Ámbar',
      coral: 'Coral',
      sky: 'Cielo',
    },
  },
  privacy: {
    title: 'Privacidad',
    lead: 'El tamaño mínimo de grupo para estadísticas agregadas y lo que tu empresa comparte.',
    minGroupSize: 'Tamaño mínimo de grupo (k-anonimato)',
    minGroupSizeHint:
      'Por debajo de esto, un grupo es demasiado pequeño para mostrar estadísticas agregadas.',
    minGroupSizeValue: '{{count}} personas',
    effective: 'Actualmente en vigor: {{count}} personas',
    aggregatedData: 'Datos agregados',
    aggregatedDataHint: 'Mostrar estadísticas agregadas para grupos que alcancen el tamaño mínimo.',
    explicitConsent: 'Consentimiento explícito requerido',
    explicitConsentHint:
      'Exigir una respuesta de consentimiento individual en lugar de un consentimiento colectivo.',
    dataExport: 'Exportación de datos',
    dataExportHint: 'Permitir exportar los datos estadísticos.',
    auditLogHint: 'Las acciones administrativas siempre se registran en un registro de auditoría.',
  },
  modules: {
    title: 'Módulos',
    lead: 'Activa o desactiva los módulos disponibles para tu empresa.',
    vitality: 'Vitalidad',
    vitalityHint: 'Seguimiento del sueño, estrés, frecuencia cardíaca y actividad.',
    participation: 'Participación',
    participationHint: 'Embudo de participación y métricas de engagement.',
    pilots: 'Pilotos',
    pilotsHint: 'Ejecuta y realiza un seguimiento de programas piloto.',
    challenges: 'Desafíos',
    challengesHint: 'Crea y gestiona desafíos de bienestar.',
    communication: 'Comunicación',
    communicationHint: 'Envía notificaciones y mensajes a los empleados.',
    documents: 'Documentos',
    documentsHint: 'Publica y gestiona documentos de la empresa.',
    reports: 'Reportes',
    reportsHint: 'Genera y exporta reportes analíticos.',
    ai_coach: 'Entrenador de IA',
    ai_coachHint: 'Coaching personalizado impulsado por inteligencia artificial.',
  },
};
